module.exports = __webpack_public_path__ + "img/copy.800ef942.svg";